<ng-container *ngIf="searchTranslations$ | async as searchTranslations">
  <ng-container *ngIf="validationResource$ | async as validationResource">
    <ng-container
      *ngIf="packingListTranslations$ | async as packingListTranslations"
    >
      <ng-container
        *ngIf="
          dangerousGoodListTranslations$
            | async as dangerousGoodListTranslations
        "
      >
        <div id="ch-ggs-web-suite-packing-details">
          <hazmatsuite-next-article-selection-button
            *ngIf="showLoadFromArticles"
            [transportMode]="transportMode"
            (selectArticle)="selectArticle($event)"
          >
          </hazmatsuite-next-article-selection-button>
          <form [formGroup]="form">
            <div class="form-group row mt-4">
              <label for="unNumber" class="col-sm-3 col-form-label">{{
                packingListTranslations['DangerousGoodSelectionUnNumberTitle']
              }}</label>
              <div class="col-sm-8">
                <span
                  class="e-input-group e-control-wrapper e-ddl"
                  aria-owns="unNumber_options"
                  aria-autocomplete="both"
                  aria-labelledby="unNumber_hidden"
                  aria-haspopup="true"
                  aria-expanded="false"
                  aria-readonly="false"
                  style="width: 100%"
                  ><select
                    aria-hidden="true"
                    tabindex="-1"
                    class="e-ddl-hidden"
                    name="unNumber"
                    id="unNumber_hidden"
                  ></select
                  ><input
                    id="unNumber"
                    formControlName="unNumber"
                    (keyup)="unNumberChanged($event)"
                    class="e-control e-autocomplete e-lib e-input e-keyboard"
                    role="combobox"
                    type="text"
                    placeholder="UN-Nummer hier eingeben"
                    aria-placeholder="UN-Nummer hier eingeben"
                    tabindex="0"
                    aria-owns="unNumber_options"
                    aria-autocomplete="both"
                    aria-labelledby="unNumber_hidden"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-readonly="false"
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false" />
                  <span
                    class="e-clear-icon e-clear-icon-hide"
                    aria-label="close"
                    role="button"
                  ></span
                ></span>
              </div>
            </div>
            <div class="form-group row">
              <label for="properShippingName" class="col-sm-3 col-form-label">
                {{
                  packingListTranslations[
                    'DangerousGoodSelectionProperShippingNameTitle'
                  ]
                }}
              </label>
              <div class="col-sm-8">
                <div>
                  <span
                    class="e-input-group e-control-wrapper e-ddl"
                    aria-owns="properShippingName_options"
                    aria-autocomplete="both"
                    aria-labelledby="properShippingName_hidden"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-readonly="false"
                    style="width: 100%"
                    ><select
                      aria-hidden="true"
                      tabindex="-1"
                      class="e-ddl-hidden"
                      name="properShippingName"
                      id="properShippingName_hidden"
                    ></select
                    ><input
                      id="properShippingName"
                      formControlName="properShippingName"
                      class="e-control e-autocomplete e-lib e-input e-keyboard"
                      role="combobox"
                      type="text"
                      placeholder="ShippingName hier eingeben"
                      aria-placeholder="ShippingName hier eingeben"
                      tabindex="0"
                      aria-owns="properShippingName_options"
                      aria-autocomplete="both"
                      aria-labelledby="properShippingName_hidden"
                      aria-haspopup="true"
                      aria-expanded="false"
                      aria-readonly="false"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      (keyup.enter)="searchProperShippingName()" />
                    <span
                      class="e-clear-icon e-clear-icon-hide"
                      aria-label="close"
                      role="button"
                    ></span
                  ></span>
                </div>
                <small
                  *ngIf="
                    properShippingName?.invalid &&
                    (properShippingName?.dirty || properShippingName?.touched)
                  "
                  class="text-danger"
                >
                  {{ validationResource['InputRequired'] }}
                </small>
              </div>
              <div class="col-sm-1">
                <a
                  href="javascript:void(0)"
                  (click)="searchProperShippingName()"
                  class="col-sm-1 col-form-label ifc-custom ifc-arrow-right"
                ></a>
              </div>
            </div>
          </form>
        </div>
        <div class="table-responsive" id="dangerousGoodList">
          <ng-container *ngIf="dangerousGoods$ | async as dangerousGoods">
            <ng-container *ngIf="dangerousGoods?.length; else noResults">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">
                      {{ searchTranslations['Identification'] }}
                    </th>
                    <th scope="col">
                      {{ searchTranslations['Kennzeichnungen'] }}
                    </th>
                    <th scope="col">
                      {{ searchTranslations['Aktionen'] }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let item of dangerousGoods; trackBy: identify"
                    (click)="selectDg(item)"
                    class="clickable"
                  >
                    <td>{{ item.DefaultShippingExpression }}</td>
                    <td>
                      <img
                        *ngFor="let label of item.DangerousGoodLabels"
                        width="50"
                        height="50"
                        [src]="'/img/HazmatLabels/' + label + '.png'"
                      />
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-block btn-iconed btn-iconed-primary"
                      >
                        {{ dangerousGoodListTranslations['ButtonChoose'] }}
                        <i class="btn-icon ifc-custom ifc-arrow-right"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </ng-container>
        </div>

        <div class="row mt-6" *ngIf="showCancelButton">
          <div class="col-md-12">
            <!-- @if (Model.PackageType == EnumPackageType.SinglePacking || Model.PackageType == EnumPackageType.Tank || Model.PackageType == EnumPackageType.Bulk)
        {
            <button type="button" class="btn btn-block btn-iconed btn-iconed-default-white btn-iconed-left w-auto" onclick="closeDgSelectionModal()">@LayoutResource.ButtonCancel <i class="btn-icon ifc-custom ifc-close"></i></button>
        }
        else
        {
            <button type="button" class="btn btn-block btn-iconed btn-iconed-default-white btn-iconed-left w-auto" onclick="loadCompositePackageView()">@CompositePackagingResource.CancelButton <i class="btn-icon ifc-custom ifc-arrow-left"></i></button>
        } -->
          </div>
        </div>
        <ng-template #noResults>
          <p *ngIf="searchExecuted">
            {{ dangerousGoodListTranslations['NoResults'] }}
          </p>
        </ng-template>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
